import React, { FunctionComponent } from 'react';

import { SellingPropositionList as SellingPropositionListType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';
import Description from '../../Section/SellingPropositionList/Description';
import Image from '../../Section/SellingPropositionList/Image';
import Title from '../../Section/SellingPropositionList/Title';

export const SellingPropositionListFragment = graphql`
  fragment SellingPropositionListFragment on SanitySellingPropositionList {
    title {
      title
      level
    }
    bottomText: bottom_text
    upperText: upper_text
    variant {
      variant
    }
    sellingPropositions: selling_propositions {
      text
      title {
        title
        level
      }
      image {
        alt
        hotspot {
          x
          y
        }
        asset {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 920, placeholder: BLURRED)
            }
          }
        }
      }
    }
    ctas {
      ...CtaFragment
    }
  }
`;

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    root: {
      ' > *:not(last-child)': {
        marginBottom: spacing(4),
      },
    },
    buttons: {
      boxSizing: 'border-box',
      padding: spacing(0, 4),
    },
  } as const;
};

const SellingPropositionList: FunctionComponent<SellingPropositionListType> = (props) => {
  const { upperText, bottomText, ctas, title, sellingPropositions } = props;

  const classes = useStyles();

  return (
    <BreakpointContainer padding={{ xs: [4, 0], md: 4 }} width="100%" maxWidth="xl">
      <Flex flexDirection="column" width="100%" css={classes.root}>
        <Title title={title} standalone={!upperText} />

        <Description>{upperText}</Description>

        <Flex flexDirection={{ xs: 'column', md: 'row' }} justifyContent="center" flexWrap="wrap">
          {sellingPropositions?.map((image, i) => (
            <Image key={i} {...image} />
          ))}
        </Flex>

        <Description>{bottomText}</Description>

        <Flex width="100%" justifyContent="center" css={classes.buttons}>
          <Buttons ctas={ctas} />
        </Flex>
      </Flex>
    </BreakpointContainer>
  );
};

export default SellingPropositionList;
